import Vue from 'vue'
import './bootstrap'
import './vee-validate'
import './calendar'
import './filters'
import './directives'
import './plugins'

Vue.config.productionTip = false

export default Vue
